/* unplugin-vue-components disabled */import { render } from "./message_notification.vue?vue&type=template&id=fbfddf58&scoped=true"
import script from "./message_notification.vue?vue&type=script&lang=js"
export * from "./message_notification.vue?vue&type=script&lang=js"

import "./message_notification.vue?vue&type=style&index=0&id=fbfddf58&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfddf58"]])

export default __exports__